export const textStyles = {
  heroText: {
    fontSize: ["65px", "40px"],
    fontWeight: "bold",
  },
  h1: {
    // you can also use responsive styles
    fontSize: ["48px", "72px"],
    fontWeight: "bold",
    lineHeight: "110%",
    letterSpacing: "-2%",
  },
  h2: {
    fontSize: ["36px", "48px"],
    fontWeight: "semibold",
    lineHeight: "110%",
    letterSpacing: "-1%",
  },
  headText: {
    fontFamily: `'Neue Montreal', sans-serif`,
  },
  bodyText: {
    fontFamily: `'Neue Montreal', sans-serif`,
  },
}
